import KeyIcon from '@mui/icons-material/Key'
import PhoneIcon from '@mui/icons-material/Phone'
import Visibility from '@mui/icons-material/Visibility'
import VisibilityOff from '@mui/icons-material/VisibilityOff'
import { Box, Container, IconButton, InputAdornment, Typography } from '@mui/material'
import { Dispatch } from '@reduxjs/toolkit'
import _ from 'lodash'
import { useSnackbar } from 'notistack'
import qs from 'qs'
import React, { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import * as Yup from 'yup'

import * as routes from '../../config/constants'
import Button from '../../shared/Button'
import { Form, FormField, SubmitButton } from '../../shared/forms'
import LoadingButtonForm from '../../shared/forms/LoadingButtonForm'
import {
  login,
  getUser,
  getLoading,
  setLogged,
  getError,
  getMessage,
  setMessage,
  setError,
  loginGateway,
} from '../../store/auth'
interface FormValues {
  phoneNumber: string
  password: string
}
// Define initialValues and  validationSchema form
const initialValues: FormValues = { phoneNumber: '', password: '' }

const validationSchema = Yup.object().shape({
  phoneNumber: Yup.string()
    .max(11, 'شماره همراه بیشتر از 11 کاراکتر نمی تواند باشد')
    .required('ورود شماره همراه اجباری است')
    .label('phone number'),
  password: Yup.string()
    .required('ورود رمز عبور اجباری است')
    .min(4, 'رمز عبور حداقل می بایست 4 حرف باشد'),
})
interface State {
  password: string
  showPassword: boolean
}

const LoginScreen: React.FC = () => {
  // Define states and  Selectors components
  const [values, setValues] = React.useState<State>({
    password: '',
    showPassword: false,
  })
  const { t } = useTranslation()
  const error = useSelector(getError)
  const message = useSelector(getMessage)
  const { enqueueSnackbar } = useSnackbar()

  const dispatch = useDispatch<Dispatch<any>>()
  const user = useSelector(getUser)
  const loading = useSelector(getLoading)
  const navigate = useNavigate()
  // useEffect
  useEffect(() => {
    if (message === undefined) return
    enqueueSnackbar(message, { variant: 'success' })
    dispatch(setMessage(undefined))
  }, [message])
  useEffect(() => {
    if (error === undefined) return
    enqueueSnackbar(error, { variant: 'error' })

    dispatch(setError(undefined))
  }, [error])
  useEffect(() => {
    if (user === undefined) return
    navigate(`/${routes.CARS}`)
  }, [user])

  const handleSubmit = (values: any) => {
    if((values.phoneNumber as string).startsWith('0')){
      dispatch(
        login({ username: _.replace(values.phoneNumber, '0', '+98'), password: values.password }),
      )
    }
    else{
      dispatch(
        login({ username: values.phoneNumber, password: values.password }),
      )
    }
  }

  const handleClickShowPassword = () => {
    setValues({
      ...values,
      showPassword: !values.showPassword,
    })
  }

  const handleMouseDownPassword = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault()
  }
  return (
    <Container fixed maxWidth='xs'>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          height: '100vh',
        }}
      >
        <Box display='flex' justifyContent='center'>
          <img alt='Logo' src='images/Logo.png' />
        </Box>
        <Box sx={{ mb: 2, ml: 1, direction: 'rtl' }}>
          <Typography sx={{ color: 'grey.700' }} variant='h5'>
            {t('screens.auth.login.title')}
          </Typography>
        </Box>
        <Box sx={{ direction: 'ltr' }}>
          <Form
            initialValues={initialValues}
            onSubmit={handleSubmit}
            validationSchema={validationSchema}
          >
            <FormField
              name='phoneNumber'
              placeholder={t('screens.auth.login.phone_number_placeholder')}
              startAdornment={
                <InputAdornment position='start'>
                  <PhoneIcon />
                </InputAdornment>
              }
            />
            <FormField
              endAdornment={
                <InputAdornment position='end'>
                  <IconButton
                    aria-label='toggle password visibility'
                    edge='end'
                    onClick={handleClickShowPassword}
                    onMouseDown={handleMouseDownPassword}
                  >
                    {values.showPassword ? <VisibilityOff /> : <Visibility />}
                  </IconButton>
                </InputAdornment>
              }
              name='password'
              placeholder={t('screens.auth.login.password_placeholder')}
              startAdornment={
                <InputAdornment position='start'>
                  <KeyIcon />
                </InputAdornment>
              }
              type={values.showPassword ? 'text' : 'password'}
            />

            <LoadingButtonForm loading={loading} title='ورود' variant='contained' />
          </Form>
        </Box>
        <Box sx={{ mt: 2, display: 'flex', justifyContent: 'space-between' }}>
          <Button onClick={() => navigate(`/${routes.REGISTER}`)} variant='text'>
            {t('screens.auth.login.register_button_text')}
          </Button>
          <Button
            onClick={() => navigate(`/${routes.FORGET_PASSWORD}`, { replace: true })}
            variant='text'
          >
            {t('screens.auth.login.forget_password_button_text')}
          </Button>
        </Box>
      </Box>
    </Container>
  )
}

export default LoginScreen
